import { Caption } from '@components/utils/text';
import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { AdditionalProductFragment } from '@graphql/generated/graphql';
import { useCompanyConfig } from '@lib/config/hooks';
import StrapiImage from '@lib/image/strapiImage';
import { getStrapiAssetUrl } from '@lib/strapi';
import { VStack } from '@lib/uikit';

type Props = { additionalProduct: AdditionalProductFragment };

const imageStyle = ({ theme }: { theme: Theme }) => css`
    object-fit: cover;
    border-radius: ${theme.shape.radius.default};
`;

const SStrapiImage = styled(StrapiImage)`
    ${imageStyle}
`;

const StyledImage = styled.img`
    ${imageStyle}
`;

const Title = styled.p`
    font: ${({ theme }) => theme.fonts.heading3};
    color: ${({ theme }) => theme.palette.text.primary};
`;

export const AdditionalProductFlowPagePreview = ({
    additionalProduct,
}: Props) => {
    const { additionalProduct: additionalProductRenderOptions } =
        useCompanyConfig();

    return (
        <VStack align='center' textAlign='center'>
            {additionalProduct.ImageUrl ? (
                <StyledImage
                    src={additionalProduct.ImageUrl}
                    alt={additionalProduct.Name}
                />
            ) : additionalProduct.Image ? (
                <SStrapiImage
                    sizes='13rem'
                    src={getStrapiAssetUrl(additionalProduct.Image)}
                    formats={additionalProduct.Image?.formats}
                    alt={
                        additionalProduct.Image?.alternativeText ??
                        additionalProduct.Name
                    }
                />
            ) : null}
            <Title>{additionalProduct.Name}</Title>
            {additionalProductRenderOptions.withDescription.inDetail &&
                additionalProduct.Description && (
                    <Caption>{additionalProduct.Description}</Caption>
                )}
        </VStack>
    );
};
